import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgUsdt = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#usdt_svg__a)'>
      <path fill='#1BA27A' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M6.534 6H17.84v2.73h-4.288v1.805c3.343.14 5.873.798 5.873 1.589s-2.53 1.448-5.874 1.59v5.756h-2.729v-5.76C7.504 13.567 5 12.91 5 12.125c0-.787 2.504-1.442 5.822-1.587V8.73H6.534zm4.288 4.69c-2.879.124-5.033.625-5.033 1.225 0 .692 2.876 1.254 6.424 1.254 3.547 0 6.423-.562 6.423-1.254 0-.603-2.18-1.107-5.084-1.227v2.053h-2.73z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='usdt_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgUsdt)
export default ForwardRef
